import { createAction } from 'redux-starter-kit';

/**
 * Puts a vehicle object into the store.
 * @example dispatch(putVehicle(vehicle))
 */
export const putVehicle = createAction('PUT_VEHICLE');

/**
 * Puts a list of vehicle objects into the store.
 * @example dispatch(putVehicles(vehicles))
 */
export const putVehicles = createAction('PUT_VEHICLES');

/**
 * Puts a list of vehicle damages objects into the store.
 * @example dispatch(putVehicleDamages(vehicles))
 */
export const putVehicleDamages = createAction('PUT_VEHICLE_DAMAGES');

export const putVehiclesPostDamages = createAction('PUT_VEHICLES_POST_DAMAGES');

export const putVehicleRetirement = createAction('PUT_VEHICLE_RETIREMENT');

export const putVehicleReinstated = createAction('PUT_VEHICLE_REINSTATED');

export const putVehicleUsage = createAction('PUT_VEHICLE_ANY_USAGE');

export const putVehicleSavedUsage = createAction('PUT_VEHICLE_SAVED_USAGE');

export const deleteVehicle = createAction('DELETE_VEHICLE');
